<template>
  <div>
    <!-- Layout -->
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb -->
    <div class="mb-3 row">
      <div class="col-11">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/tramite">Trámites</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm', params: { idTramite } }">
                Trámite N.° {{ idTramite }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm',
                                  params: { p_idtramite },
                                  query: { tab: 'reportes' } }">
                Reportes
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Procedimientos sin Mapear
            </li>
          </ol>
        </nav>
      </div>
      <div class="col-1 text-end">
        <span
          class="material-symbols-outlined text-primary"
          style="font-size: 32px; cursor: pointer"
          @click="showModalHelp = true"
        >
          help
        </span>
      </div>
    </div>

    <!-- Info del trámite -->
    <div class="card border-0 mb-3" style="background-color: #e8f4fd;">
      <div class="card-body py-2 px-3">
        <span class="text-dark fw-bold">{{ datosTramite }}</span>
      </div>
    </div>

    <!-- Toolbar -->
    <div class="d-flex gap-2 mb-3">
      <button
        class="btn btn-outline-primary"
        @click="cargar"
        :disabled="cargando || ejecutando"
      >
        <span class="material-symbols-outlined align-middle">preview</span>
        {{ cargando ? 'Cargando...' : 'Ver Preview' }}
      </button>
      <button
        class="btn btn-outline-secondary"
        @click="dryRun"
        :disabled="cargando || ejecutando"
      >
        <span class="material-symbols-outlined align-middle">play_circle</span>
        {{ ejecutando ? 'Simulando...' : 'Simular' }}
      </button>
      <button
        class="btn btn-danger"
        @click="ejecutar"
        :disabled="!hayDatos || ejecutando || cargando"
      >
        <span class="material-symbols-outlined align-middle">block</span>
        {{ ejecutando ? 'Anulando...' : 'Anular Sin Mapear' }}
      </button>
    </div>

    <!-- Consola de mensajes -->
    <div v-if="mensajes.length > 0" class="mb-3">
      <div class="d-flex align-items-center justify-content-between mb-1">
        <span class="fw-bold text-secondary">
          <span class="material-symbols-outlined align-middle">terminal</span>
          Log del proceso
        </span>
        <button class="btn btn-sm btn-outline-secondary" @click="mensajes = []">
          <span class="material-symbols-outlined align-middle" style="font-size:1rem;">
            delete
          </span>
          Limpiar
        </button>
      </div>
      <div class="consola p-3 rounded">
        <div
          v-for="(m, i) in mensajes"
          :key="i"
          class="consola-linea"
          :class="'nivel-' + m.nivel.toLowerCase()"
        >
          <span class="consola-nivel">{{ m.nivel }}</span>
          <span class="consola-mensaje">{{ m.mensaje }}</span>
        </div>
      </div>
    </div>

    <!-- Error -->
    <div v-if="error" class="alert alert-danger">
      <span class="material-symbols-outlined align-middle">error</span>
      {{ error }}
    </div>

    <!-- Sin datos -->
    <div v-if="!hayDatos && !cargando && consultado" class="alert alert-success">
      <span class="material-symbols-outlined align-middle">check_circle</span>
      No hay procedimientos sin homologar para este trámite.
    </div>

    <!-- Spinner -->
    <div v-if="cargando" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>

    <!-- Tabla -->
    <template v-if="hayDatos">
      <!-- Resumen -->
      <div class="d-flex align-items-center gap-3 mb-3">
        <div class="card border-0 px-3 py-2" style="background-color:#fef2f2;">
          <small class="text-muted">Registros sin homologar</small>
          <span class="fw-bold text-danger fs-5">{{ datos.length }}</span>
        </div>
        <div class="card border-0 px-3 py-2" style="background-color:#fff7ed;">
          <small class="text-muted">Planillas afectadas</small>
          <span class="fw-bold text-warning fs-5">{{ planillasUnicas }}</span>
        </div>
      </div>

      <div class="card border-0 shadow">
        <div class="card-header d-flex align-items-center gap-2"
             style="background-color:#fef2f2;">
          <span class="material-symbols-outlined text-danger">warning</span>
          <span class="fw-bold text-danger">
            Procedimientos sin homologar — serán anulados
          </span>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>Planilla</th>
                  <th>Paciente</th>
                  <th>Cédula</th>
                  <th>Código</th>
                  <th>Descripción</th>
                  <th class="text-center">Cantidad</th>
                  <th class="text-center">Fecha Atención</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="f in datos" :key="f.idPlanillaDet" @dblclick="abrirPlanillaPopup(f.idPlanilla)">
                  <td class="fw-bold">{{ f.planillaNumero }}</td>
                  <td>{{ f.planillaNombre }}</td>
                  <td>{{ f.planillaCedula }}</td>
                  <td>
                    <span class="badge bg-danger">{{ f.codigo }}</span>
                  </td>
                  <td>{{ f.descripcion }}</td>
                  <td class="text-center">{{ f.cantidad }}</td>
                  <td class="text-center">{{ formatFecha(f.fechaAtencion) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>

    <!-- Modal Ayuda -->
    <div v-if="showModalHelp" class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <span class="material-symbols-outlined align-middle">help</span>
              Ayuda — Procedimientos sin Mapear
            </h5>
            <button type="button" class="btn-close" @click="showModalHelp = false" />
          </div>
          <div class="modal-body">
            <p>
              Este proceso identifica y anula los registros de detalle de planilla
              que no tienen un elemento homologado asignado (<code>id_elemento IS NULL</code>).
            </p>
            <ol>
              <li>
                <strong>Ver Preview</strong>: lista los registros afectados
                sin modificar datos.
              </li>
              <li>
                <strong>Simular</strong>: muestra el log del proceso en modo
                DRY-RUN sin modificar datos.
              </li>
              <li>
                <strong>Anular Sin Mapear</strong>: desactiva los registros
                (<code>estado = 0</code>) de forma definitiva.
              </li>
            </ol>
            <p class="text-muted">
              Los registros anulados quedan inactivos para auditoría.
            </p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showModalHelp = false">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showModalHelp"
      class="modal-backdrop fade show"
      @click="showModalHelp = false"
    />

  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import api from "@/services/api";
import { abrirPlanillaPopup } from "@/assets/js/popup.js";

export default {
  name: "SinHomologar",
  components: { Layout },

  props: {
    p_idtramite: { type: String, required: true }
  },

  data() {
    return {
      idTramite:     Number(this.p_idtramite),
      datos:         [],
      cargando:      false,
      ejecutando:    false,
      consultado:    false,
      error:         null,
      showModalHelp: false,
      datosTramite:  "",
      mensajes:      [],
    };
  },

  computed: {
    hayDatos() {
      return this.datos.length > 0;
    },
    planillasUnicas() {
      return new Set(this.datos.map(f => f.planillaNumero)).size;
    }
  },

  async mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.datosTramite = sessionStorage.getItem("datosTramite");
  },

  methods: {
    formatFecha(fecha) {
      if (!fecha) return "-";
      return new Date(fecha).toLocaleDateString("es-EC");
    },

    async cargar() {
      this.cargando   = true;
      this.error      = null;
      this.consultado = false;
      try {
        const { data } = await api.get("/sin-mapear/preview", {
          params: { idTramite: this.idTramite }
        });
        this.datos = data;
      } catch (e) {
        this.error = "Error al cargar el preview: " + e.message;
      } finally {
        this.cargando   = false;
        this.consultado = true;
      }
    },

    async dryRun() {
      this.ejecutando = true;
      this.mensajes   = [];
      this.error      = null;
      try {
        const { data } = await api.post("/sin-mapear/dry-run", null, {
          params: { idTramite: this.idTramite }
        });
        this.mensajes = data;
      } catch (e) {
        this.error = "Error en simulación: " + e.message;
      } finally {
        this.ejecutando = false;
      }
    },

    async ejecutar() {
      if (!confirm("¿Confirmar anulación? Esta acción modificará los datos.")) return;
      this.ejecutando = true;
      this.mensajes   = [];
      this.error      = null;
      try {
        const { data } = await api.post("/sin-mapear/ejecutar", null, {
          params: { idTramite: this.idTramite }
        });
        this.mensajes = data;
        await this.cargar();
      } catch (e) {
        this.error = "Error al ejecutar: " + e.message;
      } finally {
        this.ejecutando = false;
      }
    },
  abrirPlanillaPopup(idPlanilla) {
    abrirPlanillaPopup(idPlanilla);
  },

  }
};
</script>

<style scoped>
.modal-content {
  background-color: #f9fafb;
}
table {
  width: 100%;
  border-collapse: collapse;
}
th {
  background-color: #e0f2fe;
  color: #0369a1;
  font-weight: bold;
  padding: 0.5rem;
  border: 1px solid #bae6fd;
}
td {
  padding: 0.5rem;
  border: 1px solid #e0f2fe;
}
tr:nth-child(even) {
  background-color: #f0f9ff;
}
tr:hover {
  background-color: #dbeafe;
}
.consola {
  background-color: #1e1e2e;
  font-family: 'Courier New', monospace;
  font-size: 0.85rem;
  max-height: 300px;
  overflow-y: auto;
}
.consola-linea {
  display: flex;
  gap: 0.75rem;
  padding: 2px 0;
  border-bottom: 1px solid #2a2a3e;
}
.consola-nivel {
  min-width: 70px;
  font-weight: bold;
  text-align: center;
  border-radius: 3px;
  padding: 0 4px;
}
.consola-mensaje {
  color: #cdd6f4;
}
.nivel-ok    .consola-nivel { background-color: #166534; color: #bbf7d0; }
.nivel-info  .consola-nivel { background-color: #1e3a5f; color: #bae6fd; }
.nivel-skip  .consola-nivel { background-color: #3f3f00; color: #fef08a; }
.nivel-error .consola-nivel { background-color: #7f1d1d; color: #fecaca; }
</style>